import { MyInvoices } from '@src/pages/ticketRestaurant/index';

const GiftMyInvoices = () => {
  return <MyInvoices isCompliments={true} />;
};

export default GiftMyInvoices;
